import { InterpolationPrimitive } from '@emotion/serialize'
import { Text, Title, Title_h2_default } from 'components/Typography'
import { SSideColumn, STextColumn, SWizardHeading } from './WizardHeadingWithSideContent.styled'
import { WizardSubtitle } from 'components/wizard/WizardTypography'
import React, { ReactElement } from 'react'

export interface WizardHeadingWithSideContentProps {
  title: string
  subtitle: string
  description?: string
  side?: ReactElement
  textColumnCss?: InterpolationPrimitive
  sideColumnCss?: InterpolationPrimitive
  children?: React.ReactNode
}

export function WizardHeadingWithSideContent(props: WizardHeadingWithSideContentProps) {
  return (
    <SWizardHeading>
      <STextColumn css={props.textColumnCss}>
        <WizardSubtitle css={{ margin: '8px 0' }}>{props.subtitle}</WizardSubtitle>

        <Title variant={Title_h2_default} as="h2" css={{ marginBottom: '1rem' }}>
          {props.title}
        </Title>

        <Text>{props.description}</Text>
        {props.children}
      </STextColumn>
      <SSideColumn css={props.sideColumnCss}>{props.side}</SSideColumn>
    </SWizardHeading>
  )
}
